class KlapiVideoCarousel extends HTMLElement {

  connectedCallback() {
    this.videoModal   = this.querySelector(".klapi-video-review-modal");
    this.overlay      = this.querySelector(".klapi-video-block-overlay");
    this.playBtn      = this.querySelector(".klapi-play-pause");
    this.muteBtn      = this.querySelector(".klapi-mute");
    this.videoButtons = this.querySelectorAll(".klapi-video-player-button");
    this.videos       = this.querySelectorAll("[id^='main_video_popup_']");
    this.toggleBtns   = this.querySelectorAll(".klapi-video-toggle");
    this.swiper       = null;

    if (this.videoModal && this.videoModal.parentElement !== document.body) {
      document.body.appendChild(this.videoModal);
    }

    this.initThumbsSwiper();
    this.initListeners();
  }

  initThumbsSwiper() {
    const thumbsEl = this.querySelector(".klapi-thumbs-swiper");
    if (!thumbsEl) return;
    new Swiper(thumbsEl, {
      slidesPerView: "auto",
      spaceBetween: 16,
      freeMode: true,
    });
  }

  initListeners() {
    this.videoModal?.addEventListener("click", e => {
      const content = this.videoModal.querySelector("#video_review_modal_content");
      if (content && !content.contains(e.target)) this.fermer();
    });

    this.toggleBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        if (this.videoModal.classList.contains("active")) {
          this.fermer();
        } else {
          const index = parseInt(btn.dataset.activeSlide ?? 0, 10);
          this.ouvrir(index);
        }
      });
    });

    this.playBtn?.addEventListener("click", () => this.togglePlay());
    this.muteBtn?.addEventListener("click", () => this.toggleMute());

    this.videos.forEach(video => {
      const container = video.closest("[data-video-block]");
      if (!container) return;

      video.addEventListener("timeupdate", () => {
        const pct = video.ended ? "100%" : `${video.currentTime / video.duration * 100}%`;
        container.querySelector(".inner").style.width = pct;
        if (video.ended) this.setPlayState(false);
      });

      // Zone play — gauche/centre/droite
      container.querySelector(".klapi-play")?.addEventListener("click", e => {
        e.stopPropagation();
        if (this.swiper && !this.swiper.allowClick) return;

        const rect = e.currentTarget.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const third = rect.width / 3;

        if (clickX < third) {
          this.swiper?.slidePrev();
        } else if (clickX > third * 2) {
          this.swiper?.slideNext();
        } else {
          video.paused ? this.playVideo(video) : this.pauseVideo(video);
        }
      });

      container.querySelector(".klapi-timeline")?.addEventListener("click", e => {
        const bar = e.currentTarget;
        const ratio = (e.clientX - bar.getBoundingClientRect().left) / bar.offsetWidth;
        video.currentTime = ratio * video.duration;
      });
    });
  }

  ouvrir(index = 0) {
    this.videoModal.classList.add("active");
    document.body.dataset.scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.width = "100%";
    this.videoButtons.forEach(b => b.setAttribute("data-state", "active"));

    setTimeout(() => {
      if (!this.swiper) {
        const prevEl = this.videoModal.querySelector("[class*='carousel-video-button-prev']");
        const nextEl = this.videoModal.querySelector("[class*='carousel-video-button-next']");

        this.swiper = new Swiper(this.videoModal.querySelector("#video-popup"), {
          spaceBetween: 20,
          allowTouchMove: true,
          navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
          on: {
            slideChange: () => {
              this.resetAll();
              setTimeout(() => {
                const activeVideo = this.videoModal.querySelector(".swiper-slide-active [id^='main_video_popup_']");
                if (activeVideo) this.playVideo(activeVideo);
              }, 50);
            }
          }
        });
      }

      this.swiper.update();
      this.swiper.slideTo(index, 0, false);

      setTimeout(() => {
        const activeVideo = this.videoModal.querySelector(".swiper-slide-active [id^='main_video_popup_']")
                         || this.videos[0];
        if (activeVideo) this.playVideo(activeVideo);
      }, 50);

    }, 100);
  }

  fermer() {
    this.resetAll();
    this.videoModal.classList.remove("active");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    window.scrollTo(0, parseInt(document.body.dataset.scrollY || "0"));
    this.videoButtons.forEach(b => b.setAttribute("data-state", "inactive"));
  }

  resetAll() {
    this.videos.forEach(video => {
      video.pause();
      video.currentTime = 0;
      const container = video.closest("[data-video-block]");
      if (container) {
        container.querySelector(".inner").style.width = "0";
        container.querySelector(".klapi-play").style.opacity = "1";
      }
    });
    this.setPlayState(false);
  }

  togglePlay() {
    const activeVideo = this.videoModal.querySelector(".swiper-slide-active [id^='main_video_popup_']")
                     || this.videos[0];
    if (!activeVideo) return;
    activeVideo.paused ? this.playVideo(activeVideo) : this.pauseVideo(activeVideo);
  }

  playVideo(video) {
    video.play();
    this.setPlayState(true);
    const container = video.closest("[data-video-block]");
    if (container) container.querySelector(".klapi-play").style.opacity = "0";
  }

  pauseVideo(video) {
    video.pause();
    this.setPlayState(false);
    const container = video.closest("[data-video-block]");
    if (container) container.querySelector(".klapi-play").style.opacity = "1";
  }

  setPlayState(playing) {
    if (!this.playBtn) return;
    this.playBtn.setAttribute("data-state", playing ? "play" : "pause");
    this.playBtn.querySelector(".play").style.display  = playing ? "none" : "flex";
    this.playBtn.querySelector(".pause").style.display = playing ? "flex" : "none";
  }

  toggleMute() {
    if (!this.muteBtn) return;
    const isMuted = this.muteBtn.getAttribute("data-state") === "unmute";
    this.videos.forEach(v => { v.muted = !isMuted; });
    this.muteBtn.setAttribute("data-state", isMuted ? "mute" : "unmute");
    this.muteBtn.querySelector(".mute").style.display   = isMuted ? "flex" : "none";
    this.muteBtn.querySelector(".unmute").style.display = isMuted ? "none" : "flex";
  }
}

customElements.define("klapi-video-carousel", KlapiVideoCarousel);